import React, { useState, useEffect } from "react"

export default function SidebarItem({ item, onCallback, defaultOpen }) {
    const [open, setOpen] = useState(false)

    const callback = (val) => {
        if (onCallback)
            onCallback(val);
    }
    useEffect(() => {
        if (defaultOpen)
            setOpen(true);
    }, [defaultOpen]);
    return (
        <div className={`sidebar-item ${open ? 'open' : ''}`}>
            <div className="sidebar-title">
                {item.subFolders && item.subFolders.length > 0 ?
                    <i className="bi-chevron-down toggle-btn" onClick={() => setOpen(!open)}></i> :
                    <i className="toggle-btn">&nbsp;&nbsp;&nbsp;&nbsp;</i>}
                <span className={item.selected ? 'selected' : ''} onClick={() => callback(item)}>
                    <img src="/Assets/folder-icon.svg" alt="Folder Icon" />
                    {item.name}
                </span>
            </div>
            {
                !item.subFolders ? null :
                    <div className="sidebar-content">
                        {item.subFolders.map((child, index) => <SidebarItem key={index} item={child} onCallback={onCallback} />)}
                    </div>
            }
        </div>
    )
}